import { addDays, mondayOf } from '@forecastify/shared';
import type { Locale } from '../../i18n';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 20 Oct 2026 · Phase 6 · D6 · the Erőforrás grid's weeks.                  │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * A week is its Monday as `YYYY-MM-DD` — the key the server stores (`weekStart`, refused when it
 * is not a Monday). ⚠️ Calendar dates, not instants: every sum here is built from the date's own
 * parts, so a Monday never becomes a Sunday west of Greenwich (`hard-won.md`).
 */

/** Every Monday from `from`'s week to `to`'s, inclusive. */
export function mondaysBetween(from: string, to: string): string[] {
  const out: string[] = [];
  const last = mondayOf(to);
  for (let at = mondayOf(from); at <= last && out.length < 520; at = addDays(at, 7)) {
    out.push(at);
  }
  return out;
}

/** The ISO-8601 week number of a Monday — the mockup's *45. HÉT*. */
export function isoWeek(monday: string): number {
  const [y = 1970, m = 1, d = 1] = monday.split('-').map(Number);
  /* The Thursday of a week decides which year the week belongs to; week 1 holds 4 January. */
  const thursdayOf = (at: Date): Date => {
    const copy = new Date(at.getTime());
    copy.setUTCDate(copy.getUTCDate() - ((copy.getUTCDay() + 6) % 7) + 3);
    return copy;
  };
  const thursday = thursdayOf(new Date(Date.UTC(y, m - 1, d)));
  const first = thursdayOf(new Date(Date.UTC(thursday.getUTCFullYear(), 0, 4)));
  return 1 + Math.round((thursday.getTime() - first.getTime()) / (7 * 86_400_000));
}

/** `nov. 2.` / `Nov 2` — a column head. */
export function shortDate(wire: string, locale: Locale): string {
  const [y = 1970, m = 1, d = 1] = wire.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(locale, { month: 'short', day: 'numeric' });
}
